import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const models = [
    { id: 1, title: "AI-Powered Chatbots", category: "GenAI Engagement Model", difficulty: "Beginner", description: "Automated conversational agents that can engage customers effectively.", takenBy: 200 },
    { id: 2, title: "Personalized Recommendations", category: "GenAI Engagement Model", difficulty: "Intermediate", description: "Machine learning algorithms offering tailored product recommendations to users.", takenBy: 150 },
    { id: 3, title: "Predictive Analytics", category: "GenAI Engagement Model", difficulty: "Advanced", description: "Using AI to predict customer behavior and optimize marketing strategies.", takenBy: 100 },
    { id: 4, title: "AI for Customer Support", category: "GenAI Engagement Model", difficulty: "Intermediate", description: "Leverage AI systems to enhance customer service and streamline responses.", takenBy: 130 },
    { id: 5, title: "Natural Language Processing (NLP)", category: "GenAI Engagement Model", difficulty: "Advanced", description: "Utilizing NLP for text analysis and generating insights from large datasets.", takenBy: 75 },
    { id: 6, title: "Voice Assistants", category: "GenAI Engagement Model", difficulty: "Beginner", description: "AI-driven voice assistants to improve customer interaction and support.", takenBy: 250 },
    { id: 7, title: "AI-Driven Content Creation", category: "GenAI Engagement Model", difficulty: "Intermediate", description: "AI tools for automated content generation, blogs, and social media posts.", takenBy: 180 },
    { id: 8, title: "Emotion AI", category: "GenAI Engagement Model", difficulty: "Advanced", description: "Detecting and analyzing human emotions through AI for better engagement.", takenBy: 90 },
];

const pageSize = 4;

function GenAIEngagementModel() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Beginner");

    const filteredModels = models.filter(model => model.difficulty === activeTab);
    const paginatedModels = filteredModels.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>GenAI Engagement Model</Title>
                <Paragraph>Explore innovative AI-powered engagement models designed to enhance customer interaction, support, and personalization across various touchpoints.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedModels.map((model) => (
                        <Col xs={24} sm={12} md={6} key={model.id}>
                            <Card hoverable>
                                <Title level={5}>{model.title}</Title>
                                <Tag color="blue">{model.category}</Tag>
                                <Tag color={model.difficulty === "Beginner" ? "green" : model.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {model.difficulty}
                                </Tag>
                                <Paragraph>{model.description}</Paragraph>
                                <Paragraph><UserOutlined /> {model.takenBy} engaged users</Paragraph>
                                <Button type="primary">Start Project</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredModels.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default GenAIEngagementModel;
